<template>
  <section v-if="!props.hasError" class="home_hero__pending-balance">
    <button :class="buttonClass" @click="redirectToTransactionsPage">
      <div class="home_hero__pending-balance--container">
        <BaseText :color="NebraskaColors.elementAlpha">
          Saldo em conta
        </BaseText>
        <HomeHeroSummaryLoader v-if="props.isLoading" />
        <div v-else class="home_hero__pending-balance--value">
          <BaseText :color="NebraskaColors.elementOverImage">
            <Money>{{ props.balance }}</Money>
          </BaseText>
          <BaseIcon icon="EA0170" :colors="NebraskaColors.elementOverImage" />
        </div>
      </div>
    </button>
  </section>
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router/composables';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseIcon, BaseText } from '@warrenbrasil/nebraska-web';
import * as trackEvents from '../track-events';
import HomeHeroSummaryLoader from './HomeHeroSummaryLoader.vue';
import { computed } from 'vue';
import { Money } from '@/modules/common/components/Money';

const props = defineProps<{
  isLoading: boolean;
  hasError: boolean;
  balance: string;
}>();

const router = useRouter();

const buttonClass = computed(() => {
  return `home_hero__pending-balance--content${
    props.isLoading ? ' disabled' : ''
  }
  `;
});

function redirectToTransactionsPage() {
  if (!props.isLoading) {
    trackEvents.trackViewMoreTransactionsEvent();
    router.push({ name: 'transactions' });
  }
}
</script>

<style scoped lang="less">
.home_hero {
  position: absolute;
  width: 100vw;

  :deep(.hero__content) {
    padding: 0;
    margin: 0;
  }

  :deep(.max-width) {
    max-width: 100%;
  }

  &__pending-balance {
    width: 100%;
    height: 64px;
    background-color: @divider-opacity;

    &--content {
      width: 100%;
      max-width: 1008px;
      margin: auto;
      display: block;
      height: 100%;
    }

    &--container {
      display: flex;
      justify-content: space-between;
    }

    &--value {
      display: flex;
      color: @element-over-image !important;
    }
  }
}

.disabled {
  pointer-events: none;
}
</style>
